/*{
  "name": "Room 3",
  "description": "Room 3 in set 38",
  "eduacClass": {
    "id": 26
  },
  "type": "ROOM",
  "set" : {
    "meetingId" : 38
  }
}*/
import { GROUP_TYPES } from '../values/meetings.values';

export class RequestMeeting {
  name: string;
  description?: string;
  type: GROUP_TYPES;
  meetingId?: number;
  eduacClass: {
    id: number;
  }
  set: {
    meetingId: number;
  }
  
  constructor(data: any) {
    this.name = data.name;
    this.description = data.description ? data.description : '';
    this.type = GROUP_TYPES.MANUAL_GROUP;
    this.meetingId = data.meetingId ? data.meetingId : null;
    this.eduacClass = { id:0 };
    this.eduacClass.id = data.id;
    this.set = { meetingId:0 };
    this.set.meetingId = data.setMeetingId;
  }
}